import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import { AiOutlineWarning } from "react-icons/ai";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Edit({
  visible,
  newM,
  setNewM,
  setMoamad,
  moamad,
  uEmail,
  mekhraz_title,
  hagsha_aharon,
  readOnly,
}) {
  const [displaySave, setDisplaySave] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [megdarOptions, setMegdarOptions] = useState([]);
  const [famOptions, setFamOptions] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMegdar = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "megdartype/", {
          signal: controller.signal,
        });
        isMounted && setMegdarOptions(response.data[0].megdarOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    const getFam = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "famtype/", {
          signal: controller.signal,
        });
        setFamOptions(response.data[0].famOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getMegdar();
    getFam();
    setUserEmail(uEmail);
  }, []);

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewM((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setDisplaySave(true);
  };

  const handleChangeSDD = (id, val) => {
    setNewM((prevState) => ({
      ...prevState,
      user: id,
      idz: val,
    }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setNewM((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    setDisplaySave(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "moamad/" + newM.id + "/",
          newM,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setMoamad(newM);
          setDisplaySave(false);
          alert("העדכון בוצע בהצלחה");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    updateData();
  };

  if (!visible) return;
  return (
    <Card className="border-danger container px-5" bg="light">
      <Card.Header>
        <center>
          {newM.extention_date &&
          new Date(newM.extention_date).setHours(0, 0, 0, 0) >=
            new Date().setHours(0, 0, 0, 0) ? (
            <div className="alert alert-success blinking-text" role="alert">
              <h4>
                המערכת נפתחה זמנית אך ורק להוספת מסמכים עד יום{" "}
                <strong>{newM.extention_date}</strong>.
              </h4>
            </div>
          ) : (
            ""
          )}

          {newM.signature_date ? (
            <h4 style={{ color: "green" }}>
              המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
            </h4>
          ) : (
            <h4 style={{ color: "red" }}>
              <AiOutlineWarning />
              שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
              <AiOutlineWarning />
            </h4>
          )}

          <h5 style={{ color: "blue" }}>
            עריכת פרטי המועמד לתפקיד: {mekhraz_title}
          </h5>
        </center>
      </Card.Header>
      <Card.Body>
        <form onSubmit={handleSubmit}>
          <Row className="mt-4">
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="f_name">שם פרטי</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="f_name"
                  value={newM.f_name}
                  onChange={handleChange}
                  className="form-control"
                  id="f_name"
                  placeholder=""
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="father_name">שם אב/אמצעי</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="father_name"
                  value={newM.father_name}
                  onChange={handleChange}
                  className="form-control"
                  id="father_name"
                  placeholder=""
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="l_name">שם משפחה</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="l_name"
                  value={newM.l_name}
                  onChange={handleChange}
                  className="form-control"
                  id="l_name"
                  placeholder=""
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="idz">מס תעודת זהות אוטומטי</label>
                {" " + newM.idz}
              </div>
            </Col>
            <Col sm="3" md={{ size: 4, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="birth_date">תאריך לידה</label>
                <input
                  disabled={readOnly}
                  type="date"
                  name="birth_date"
                  value={newM.birth_date}
                  onChange={handleChange}
                  className="form-control"
                  id="birth_date"
                  placeholder=""
                />
              </div>
            </Col>

            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="megdar">מגדר</label>
                <select
                  disabled={readOnly}
                  name="megdar"
                  onChange={handleChange}
                  value={newM.megdar}
                  required
                >
                  <option key="0" value="" defaultValue="0">
                    בחר סוג
                  </option>
                  {megdarOptions?.map((a) => (
                    <option key={a[0]} value={a[1]}>
                      {a[1]}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="children_num">מספר ילדים</label>
                <input
                  disabled={readOnly}
                  type="number"
                  name="children_num"
                  value={newM.children_num}
                  onChange={handleChange}
                  className="form-control"
                  id="children_num"
                  placeholder="כמו 3"
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="fam_status">מצב משפחתי</label>
                <select
                  disabled={readOnly}
                  name="fam_status"
                  onChange={handleChange}
                  value={newM.fam_status}
                  required
                >
                  <option key="0" value="">
                    בחר מצב משפחתי
                  </option>
                  {famOptions?.map((a) => (
                    <option key={a[0]} value={a[1]}>
                      {a[1]}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="citizenship">אזרחות</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="citizenship"
                  value={newM.citizenship}
                  onChange={handleChange}
                  className="form-control"
                  id="citizenship"
                  placeholder=""
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="special_needs">בעל צרכים מיוחדים?</label>
                <input
                  disabled={readOnly}
                  type="checkbox"
                  id="special_needs"
                  name="special_needs"
                  checked={newM.special_needs}
                  onChange={handleCheckBoxChange}
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="arab_droze_circassian">
                  נמנה על האוכלוסיה הערבית, הדרוזית או הצרקסית?
                </label>
                <input
                  disabled={readOnly}
                  type="checkbox"
                  id="arab_droze_circassian"
                  name="arab_droze_circassian"
                  checked={newM.arab_droze_circassian}
                  onChange={handleCheckBoxChange}
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="ethiopian">אתיופי?</label>
                <input
                  disabled={readOnly}
                  type="checkbox"
                  id="ethiopian"
                  name="ethiopian"
                  checked={newM.ethiopian}
                  onChange={handleCheckBoxChange}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="mobile_phone">מספר נייד</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="mobile_phone"
                  value={newM.mobile_phone}
                  onChange={handleChange}
                  className="form-control"
                  id="mobile_phone"
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="mobile_phone">טלפון בעבודה</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="work_phone"
                  value={newM.work_phone}
                  onChange={handleChange}
                  className="form-control"
                  id="work_phone"
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="home_phone">טלפון בבית</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="home_phone"
                  value={newM.home_phone}
                  onChange={handleChange}
                  className="form-control"
                  id="home_phone"
                  placeholder=""
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="Address">כתובת</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="Address"
                  value={newM.Address}
                  onChange={handleChange}
                  className="form-control"
                  id="Address"
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="zipcode">מיקוד</label>
                <input
                  disabled={readOnly}
                  type="text"
                  name="zipcode"
                  value={newM.zipcode}
                  onChange={handleChange}
                  className="form-control"
                  id="zipcode"
                />
              </div>
            </Col>
            <Col sm="3" md={{ size: 3, offset: 1 }}>
              <div className="form-group">
                <label htmlFor="userEmail">דואר אלקטרוני-אוטומטי-</label>
                {userEmail ? userEmail : uEmail}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="form-group">
                <label htmlFor="moamad_notes">משהו טוב שרוצה לספר</label>
                <textarea
                  disabled={readOnly}
                  name="moamad_notes"
                  cols={50}
                  rows={2}
                  value={newM.moamad_notes}
                  onChange={handleChange}
                  className="form-control"
                  id="moamad_notes"
                />
              </div>
            </Col>
          </Row>
          <br></br>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!displaySave}
          >
            שמור
          </button>
        </form>
      </Card.Body>
    </Card>
  );
}
